"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getInnerText = exports.formatInnerText = exports.findParentByTag = exports.addClickListener = void 0;
var _MatomoConfig = require("../MatomoConfig");
var _types = require("../types");
const findParentByTag = (target, tagNames, recursionLimit = 10) => {
  if (recursionLimit === 0 || !target || !(target instanceof HTMLElement)) {
    return null;
  }
  if (tagNames.includes(target.tagName.toLocaleLowerCase())) {
    return target;
  } else if (target.parentElement) {
    return findParentByTag(target.parentElement, tagNames, recursionLimit - 1);
  } else {
    return null;
  }
};
exports.findParentByTag = findParentByTag;
const formatInnerText = (innerText, textLength = 20) => innerText.substring(0, textLength) + (innerText.length > textLength ? '...' : '');
exports.formatInnerText = formatInnerText;
const getInnerText = element => {
  return formatInnerText(element.textContent ?? '');
};
exports.getInnerText = getInnerText;
const elementTypeHandler = event => {
  const element = findParentByTag(event.target, ['a', 'button']);
  if (!element) {
    return;
  }
  switch (element.tagName.toLocaleLowerCase()) {
    case 'a':
      (0, _MatomoConfig.leggTilInstruksjon)(_types.TRACK_TYPER.EVENT, 'userEvent', 'linkClick', getInnerText(element), element.href ?? '');
      break;
    case 'button':
      (0, _MatomoConfig.leggTilInstruksjon)(_types.TRACK_TYPER.EVENT, 'userEvent', 'buttonClick', getInnerText(element));
  }
};
const clickHandler = event => {
  try {
    elementTypeHandler(event);
  } catch {
    // SWALLOW
  }
};
const addClickListener = () => {
  document.addEventListener('click', clickHandler, {
    capture: true
  });
};
exports.addClickListener = addClickListener;